export const validateEmail = (email: string = ''): string | null =>
  email.match(/^\S+@\S+$/) ? null : 'Email is invalid';
